export const getCargoShipperTabs = id => {
	return [
		{ tab: 'my', text: 'Новые', href: `/reqs/${id}/my` },
		{ tab: 'approval', text: 'На согласовании', href: `/reqs/${id}/approval` },
		{ tab: 'work', text: 'В работе', href: `/reqs/${id}/work` },
		{ tab: 'completed', text: 'Завершенные', href: `/reqs/${id}/completed` },
	];
};

export const getCargoReqTabs = id => {
	if (['express', 'avia'].includes(id)) {
		return [
			{ tab: '', text: 'Новые', href: `/reqs/${id}` },
			{ tab: 'auction', text: 'Мои ставки', href: `/reqs/${id}/auction` },
			{ tab: 'tender', text: 'Мои ТЭО', href: `/reqs/${id}/tender` },
			{ tab: 'approval', text: 'На согласовании', href: `/reqs/${id}/approval` },
			{ tab: 'work', text: 'В работе', href: `/reqs/${id}/work` },
			{ tab: 'completed', text: 'Завершенные', href: `/reqs/${id}/completed` },
		];
	}

	return [
		{ tab: '', text: 'Новые', href: `/reqs/${id}` },
		{ tab: 'auction', text: 'Мои ставки', href: `/reqs/${id}/auction` },
		{ tab: 'tender', text: 'Мои ТЭО', href: `/reqs/${id}/tender` },
		{ tab: 'approval', text: 'На согласовании', href: `/reqs/${id}/approval` },
		{ tab: 'work', text: 'В работе', href: `/reqs/${id}/work` },
		{ tab: 'completed', text: 'Завершенные', href: `/reqs/${id}/completed` },
	];
};
